import React from 'react'
import { Document } from './components/document'
import { Split } from './components/split';
import { ImageView } from './components/imageview';

export class Problem extends React.Component {

    render() {
        return (
            <Split reverse={true}>
                <Document>
                    <h2>What is the problem?</h2>
                    <p>It's been 2.5 years since ChatGPT launched, yet we're still waiting for the AI agent revolution. The numbers tell the story: a recent MIT study shows that 95% of organizations get zero return on their AI investment, despite $30-40 billion in enterprise spending. The report also identifies the key problem:</p>

                    <div className="highlight">
                        <p>"The core barrier to scaling is not infrastructure, regulation, or talent. <strong><u>It is learning.</u></strong> Most GenAI systems do not retain feedback, adapt to context, or improve over time."</p>
                        <a href="https://www.artificialintelligence-news.com/wp-content/uploads/2025/08/ai_report_2025.pdf">(MIT: The GenAI Divide - State of AI IN business 2025, p.3)</a>
                    </div>

                    <p>While the world expected AI agents to transform how we work, most attempts have failed. The reason is simple: current AI models can't learn. They make the same mistakes over and over again, showing the same blind spots, failing in predictable ways. We're building agents without the ability to learn and adapt—without this capability, even the most sophisticated AI remains fundamentally limited.</p>

                </Document>
                <ImageView src="/images/training.jpeg"/>
            </Split>
        );
    }
}

